import { render, staticRenderFns } from "./PSearchInput.vue?vue&type=template&id=463f0b29"
import script from "./PSearchInput.vue?vue&type=script&lang=js"
export * from "./PSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports